import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type questionAndAnswerFieldsFragment = {
    __typename?: 'DraftManagementQuestionAndAnswer';
    question: {
        __typename?: 'DraftManagementQuestion';
        questionId: string;
        type: Types.DraftManagementQuestionType;
        indeedTaxonomyParameters: Array<{
            __typename?: 'DraftManagementIndeedTaxonomyParameter';
            parameterType: string;
            parameterValue: string;
            attributeUuid?: string | null | undefined;
        }>;
        qualification?:
            | {
                  __typename?: 'DraftManagementMatchQualification';
                  type?: Types.DraftManagementQualificationType | null | undefined;
                  match?:
                      | {
                            __typename?: 'DraftManagementQualificationMatch';
                            values: Array<string>;
                            type: Types.DraftManagementQualificationMatchType;
                        }
                      | null
                      | undefined;
              }
            | {
                  __typename?: 'DraftManagementRangeQualification';
                  type?: Types.DraftManagementQualificationType | null | undefined;
                  range?:
                      | {
                            __typename?: 'DraftManagementQualificationRange';
                            min?: string | null | undefined;
                            max?: string | null | undefined;
                        }
                      | null
                      | undefined;
              }
            | null
            | undefined;
        details:
            | {
                  __typename: 'DraftManagementDateQuestion';
                  label: string;
                  format?: string | null | undefined;
                  minValue?: string | null | undefined;
                  maxValue?: string | null | undefined;
                  requirement: Types.DraftManagementQuestionsRequirement;
              }
            | {
                  __typename: 'DraftManagementFileQuestion';
                  label: string;
                  acceptedFileExtensions: Array<string>;
                  minValue?: string | null | undefined;
                  maxValue?: string | null | undefined;
                  requirement: Types.DraftManagementQuestionsRequirement;
              }
            | {
                  __typename: 'DraftManagementHierarchicalQuestion';
                  label: string;
                  requirement: Types.DraftManagementQuestionsRequirement;
                  options: Array<{
                      __typename?: 'DraftManagementQuestionOption';
                      value?: string | null | undefined;
                      label?: string | null | undefined;
                  }>;
                  hierarchicalOptions: Array<{
                      __typename?: 'DraftManagementHierarchicalOption';
                      id?: string | null | undefined;
                      condition?: string | null | undefined;
                      options: Array<{
                          __typename?: 'DraftManagementQuestionOption';
                          value?: string | null | undefined;
                          label?: string | null | undefined;
                      }>;
                  }>;
              }
            | {
                  __typename: 'DraftManagementInformation';
                  rawText?: string | null | undefined;
                  htmlText?: string | null | undefined;
                  fontSize?: Types.DraftManagementFontSize | null | undefined;
                  condition?: string | null | undefined;
              }
            | { __typename: 'DraftManagementMultifieldQuestion' }
            | { __typename: 'DraftManagementPageBreak'; condition?: string | null | undefined }
            | {
                  __typename: 'DraftManagementSelectQuestion';
                  label: string;
                  condition?: string | null | undefined;
                  requirement: Types.DraftManagementQuestionsRequirement;
                  options: Array<{
                      __typename?: 'DraftManagementQuestionOption';
                      value?: string | null | undefined;
                      label?: string | null | undefined;
                  }>;
              }
            | {
                  __typename: 'DraftManagementTextAreaQuestion';
                  label: string;
                  maxLength?: string | null | undefined;
                  requirement: Types.DraftManagementQuestionsRequirement;
              }
            | {
                  __typename: 'DraftManagementTextBoxQuestion';
                  label: string;
                  dataType?: Types.DraftManagementDataType | null | undefined;
                  maxLength?: string | null | undefined;
                  minValue?: string | null | undefined;
                  maxValue?: string | null | undefined;
                  requirement: Types.DraftManagementQuestionsRequirement;
              };
    };
    answer?:
        | {
              __typename?: 'DraftManagementFileAnswer';
              file: { __typename?: 'DraftManagementFile'; uri?: any | null | undefined };
          }
        | {
              __typename?: 'DraftManagementHierarchicalAnswer';
              valueList: Array<{
                  __typename?: 'DraftManagementHierarchicalAnswerValue';
                  id: string;
                  value: string;
              }>;
          }
        | {
              __typename?: 'DraftManagementMultiFileAnswer';
              files: Array<{
                  __typename?: 'DraftManagementFileAnswer';
                  file: { __typename?: 'DraftManagementFile'; uri?: any | null | undefined };
              }>;
          }
        | {
              __typename?: 'DraftManagementMultiTextAnswer';
              valueList: Array<{ __typename?: 'DraftManagementTextAnswer'; value: string }>;
          }
        | { __typename?: 'DraftManagementMultifieldAnswer' }
        | { __typename?: 'DraftManagementTextAnswer'; value: string }
        | null
        | undefined;
    suggestedAnswer?:
        | {
              __typename?: 'DraftManagementMultiTextSuggestedAnswer';
              questionViewTk: string;
              suggestions: Array<{ __typename?: 'DraftManagementSuggestion'; value: string }>;
          }
        | {
              __typename?: 'DraftManagementTextSuggestedAnswer';
              questionViewTk: string;
              suggestion: { __typename?: 'DraftManagementSuggestion'; value: string };
          }
        | null
        | undefined;
};

export type GetScreenerQuestionsDataQueryVariables = Types.Exact<{
    filterInput: Types.FindApplicationDraftsFilterInput;
    nodeId: Types.Scalars['ID']['input'];
}>;

export type GetScreenerQuestionsDataQuery = {
    __typename?: 'Query';
    findApplicationDrafts?:
        | {
              __typename?: 'FindApplicationDraftsConnection';
              operationDetails: Array<{
                  __typename?: 'DraftManagementApplicationDraft';
                  applicationDraftId: string;
                  questionsAndAnswers?:
                      | {
                            __typename?: 'DraftManagementQuestionsAndAnswers';
                            screener: Array<{
                                __typename?: 'DraftManagementQuestionAndAnswer';
                                question: {
                                    __typename?: 'DraftManagementQuestion';
                                    questionId: string;
                                    type: Types.DraftManagementQuestionType;
                                    indeedTaxonomyParameters: Array<{
                                        __typename?: 'DraftManagementIndeedTaxonomyParameter';
                                        parameterType: string;
                                        parameterValue: string;
                                        attributeUuid?: string | null | undefined;
                                    }>;
                                    qualification?:
                                        | {
                                              __typename?: 'DraftManagementMatchQualification';
                                              type?:
                                                  | Types.DraftManagementQualificationType
                                                  | null
                                                  | undefined;
                                              match?:
                                                  | {
                                                        __typename?: 'DraftManagementQualificationMatch';
                                                        values: Array<string>;
                                                        type: Types.DraftManagementQualificationMatchType;
                                                    }
                                                  | null
                                                  | undefined;
                                          }
                                        | {
                                              __typename?: 'DraftManagementRangeQualification';
                                              type?:
                                                  | Types.DraftManagementQualificationType
                                                  | null
                                                  | undefined;
                                              range?:
                                                  | {
                                                        __typename?: 'DraftManagementQualificationRange';
                                                        min?: string | null | undefined;
                                                        max?: string | null | undefined;
                                                    }
                                                  | null
                                                  | undefined;
                                          }
                                        | null
                                        | undefined;
                                    details:
                                        | {
                                              __typename: 'DraftManagementDateQuestion';
                                              label: string;
                                              format?: string | null | undefined;
                                              minValue?: string | null | undefined;
                                              maxValue?: string | null | undefined;
                                              requirement: Types.DraftManagementQuestionsRequirement;
                                          }
                                        | {
                                              __typename: 'DraftManagementFileQuestion';
                                              label: string;
                                              acceptedFileExtensions: Array<string>;
                                              minValue?: string | null | undefined;
                                              maxValue?: string | null | undefined;
                                              requirement: Types.DraftManagementQuestionsRequirement;
                                          }
                                        | {
                                              __typename: 'DraftManagementHierarchicalQuestion';
                                              label: string;
                                              requirement: Types.DraftManagementQuestionsRequirement;
                                              options: Array<{
                                                  __typename?: 'DraftManagementQuestionOption';
                                                  value?: string | null | undefined;
                                                  label?: string | null | undefined;
                                              }>;
                                              hierarchicalOptions: Array<{
                                                  __typename?: 'DraftManagementHierarchicalOption';
                                                  id?: string | null | undefined;
                                                  condition?: string | null | undefined;
                                                  options: Array<{
                                                      __typename?: 'DraftManagementQuestionOption';
                                                      value?: string | null | undefined;
                                                      label?: string | null | undefined;
                                                  }>;
                                              }>;
                                          }
                                        | {
                                              __typename: 'DraftManagementInformation';
                                              rawText?: string | null | undefined;
                                              htmlText?: string | null | undefined;
                                              fontSize?:
                                                  | Types.DraftManagementFontSize
                                                  | null
                                                  | undefined;
                                              condition?: string | null | undefined;
                                          }
                                        | { __typename: 'DraftManagementMultifieldQuestion' }
                                        | {
                                              __typename: 'DraftManagementPageBreak';
                                              condition?: string | null | undefined;
                                          }
                                        | {
                                              __typename: 'DraftManagementSelectQuestion';
                                              label: string;
                                              condition?: string | null | undefined;
                                              requirement: Types.DraftManagementQuestionsRequirement;
                                              options: Array<{
                                                  __typename?: 'DraftManagementQuestionOption';
                                                  value?: string | null | undefined;
                                                  label?: string | null | undefined;
                                              }>;
                                          }
                                        | {
                                              __typename: 'DraftManagementTextAreaQuestion';
                                              label: string;
                                              maxLength?: string | null | undefined;
                                              requirement: Types.DraftManagementQuestionsRequirement;
                                          }
                                        | {
                                              __typename: 'DraftManagementTextBoxQuestion';
                                              label: string;
                                              dataType?:
                                                  | Types.DraftManagementDataType
                                                  | null
                                                  | undefined;
                                              maxLength?: string | null | undefined;
                                              minValue?: string | null | undefined;
                                              maxValue?: string | null | undefined;
                                              requirement: Types.DraftManagementQuestionsRequirement;
                                          };
                                };
                                answer?:
                                    | {
                                          __typename?: 'DraftManagementFileAnswer';
                                          file: {
                                              __typename?: 'DraftManagementFile';
                                              uri?: any | null | undefined;
                                          };
                                      }
                                    | {
                                          __typename?: 'DraftManagementHierarchicalAnswer';
                                          valueList: Array<{
                                              __typename?: 'DraftManagementHierarchicalAnswerValue';
                                              id: string;
                                              value: string;
                                          }>;
                                      }
                                    | {
                                          __typename?: 'DraftManagementMultiFileAnswer';
                                          files: Array<{
                                              __typename?: 'DraftManagementFileAnswer';
                                              file: {
                                                  __typename?: 'DraftManagementFile';
                                                  uri?: any | null | undefined;
                                              };
                                          }>;
                                      }
                                    | {
                                          __typename?: 'DraftManagementMultiTextAnswer';
                                          valueList: Array<{
                                              __typename?: 'DraftManagementTextAnswer';
                                              value: string;
                                          }>;
                                      }
                                    | { __typename?: 'DraftManagementMultifieldAnswer' }
                                    | { __typename?: 'DraftManagementTextAnswer'; value: string }
                                    | null
                                    | undefined;
                                suggestedAnswer?:
                                    | {
                                          __typename?: 'DraftManagementMultiTextSuggestedAnswer';
                                          questionViewTk: string;
                                          suggestions: Array<{
                                              __typename?: 'DraftManagementSuggestion';
                                              value: string;
                                          }>;
                                      }
                                    | {
                                          __typename?: 'DraftManagementTextSuggestedAnswer';
                                          questionViewTk: string;
                                          suggestion: {
                                              __typename?: 'DraftManagementSuggestion';
                                              value: string;
                                          };
                                      }
                                    | null
                                    | undefined;
                            }>;
                        }
                      | null
                      | undefined;
              }>;
          }
        | null
        | undefined;
    smartApplyApplicationState?:
        | { __typename?: 'AIInterviewInterview' }
        | { __typename?: 'AIJobManSubsetConfiguration' }
        | { __typename?: 'AdhocEmployerInterviewIntent' }
        | { __typename?: 'AdhocJobseekerInterviewIntent' }
        | { __typename?: 'AiDocument' }
        | { __typename?: 'AnalyticsMetricsDataResult' }
        | { __typename?: 'ApplicationDraft' }
        | { __typename?: 'Appointment' }
        | { __typename?: 'AtsSyncCandidateSyncApplication' }
        | { __typename?: 'AtsSyncCandidateSyncInterestedCandidateAsset' }
        | { __typename?: 'AtsSyncCandidateSyncSmartScreeningUpdateAsset' }
        | { __typename?: 'AuditEvent' }
        | { __typename?: 'AutomatableActionResult' }
        | { __typename?: 'AutomatableCalendlyResult' }
        | { __typename?: 'AutomatableEngagementResult' }
        | { __typename?: 'AutomatableKeyValueResult' }
        | { __typename?: 'AutomatableScreenerResult' }
        | { __typename?: 'AutomatableUpdateCandidateResult' }
        | { __typename?: 'AutosourcerBulkEnableTask' }
        | { __typename?: 'Availability' }
        | { __typename?: 'BillingAccount' }
        | { __typename?: 'BillingCreditMemo' }
        | { __typename?: 'BillingDebitMemo' }
        | { __typename?: 'BillingIdentifier' }
        | { __typename?: 'BillingInvoice' }
        | { __typename?: 'BillingPayment' }
        | { __typename?: 'BillingRefund' }
        | { __typename?: 'BulkJobContentOptimization' }
        | { __typename?: 'CalendarConfiguration' }
        | { __typename?: 'Campaign' }
        | { __typename?: 'Candidate' }
        | { __typename?: 'CandidateBio' }
        | { __typename?: 'CandidateFeedbackNote' }
        | { __typename?: 'CandidateFeedbackRating' }
        | { __typename?: 'CandidateFeedbackSentiment' }
        | { __typename?: 'CandidateJourney' }
        | { __typename?: 'CandidateJourneyGroup' }
        | { __typename?: 'CandidateJourneyStage' }
        | { __typename?: 'CandidateSubmission' }
        | { __typename?: 'CandidateSubmissionGroup' }
        | { __typename?: 'CandidateSyncSmartSourcingExportResourceHistory' }
        | { __typename?: 'CategoricalOQVTTaxonomy' }
        | { __typename?: 'ChannelNotification' }
        | { __typename?: 'ChatConversation' }
        | { __typename?: 'ChatConversationAttachment' }
        | { __typename?: 'ChatConversationMessage' }
        | { __typename?: 'CollaborationRequest' }
        | { __typename?: 'CommunicationsHubRequest' }
        | { __typename?: 'CompanyAlert' }
        | { __typename?: 'Conversation' }
        | { __typename?: 'ConversationEvent' }
        | { __typename?: 'CraveComplianceDocument' }
        | { __typename?: 'CraveEmployerDocument' }
        | { __typename?: 'CreditAllocation' }
        | { __typename?: 'CurrentCandidateSubmissionStatus' }
        | { __typename?: 'DedicatedSchedulingFormat' }
        | { __typename?: 'DeepSourcingSession' }
        | { __typename?: 'DeepSourcingSessionHighlightMatch' }
        | { __typename?: 'EjpAutomationTransaction' }
        | { __typename?: 'EjpGroup' }
        | { __typename?: 'EjpJobMatchAutomation' }
        | { __typename?: 'EmployerAdminAction' }
        | { __typename?: 'EmployerAiAutomationsGuardrail' }
        | { __typename?: 'EmployerAnalyticsSavedView' }
        | { __typename?: 'EmployerAutomation' }
        | { __typename?: 'EmployerBillingContractDeal' }
        | { __typename?: 'EmployerBillingContractLead' }
        | { __typename?: 'EmployerDealBonusCredit' }
        | { __typename?: 'EmployerEntity' }
        | { __typename?: 'EmployerHierarchy' }
        | { __typename?: 'EmployerHiringEvent' }
        | { __typename?: 'EmployerHiringEventRsvp' }
        | { __typename?: 'EmployerIntegration' }
        | { __typename?: 'EmployerJob' }
        | { __typename?: 'EmployerJobBatchEdit' }
        | { __typename?: 'EmployerJobGroup' }
        | { __typename?: 'EmployerJobHiringAdvice' }
        | { __typename?: 'EmployerJobTag' }
        | { __typename?: 'EmployerOrganization' }
        | { __typename?: 'EmployerOrganizationType' }
        | { __typename?: 'EmployerOrganizationUser' }
        | { __typename?: 'EmployerOrganizationalUnit' }
        | { __typename?: 'EmployerOrganizationalUnitUser' }
        | { __typename?: 'EmployerRegistration' }
        | { __typename?: 'EmployerUser' }
        | { __typename?: 'EmployerUserCandidateSourcingSettings' }
        | { __typename?: 'EmployerUserCandidateSourcingUxFeatures' }
        | { __typename?: 'EmployerUserGroup' }
        | { __typename?: 'EmployerUserHiringProfile' }
        | { __typename?: 'EmployerUserSettings' }
        | { __typename?: 'EvaluateWorkflow' }
        | { __typename?: 'EvaluateWorkflowStep' }
        | { __typename?: 'ExternalAtsLink' }
        | { __typename?: 'ExternalJobPost' }
        | { __typename?: 'FlexAgencyChargeRateOverride' }
        | { __typename?: 'FlexBurdenProfile' }
        | { __typename?: 'FlexExternalIntegration' }
        | { __typename?: 'FlexExternalIntegrationSyncRun' }
        | { __typename?: 'FlexPlacementMargin' }
        | { __typename?: 'FlexPlatformMargin' }
        | { __typename?: 'FlexRateCard' }
        | { __typename?: 'FlexShiftRateType' }
        | { __typename?: 'FlexTimeDependentRate' }
        | { __typename?: 'GhostwriterApplication' }
        | { __typename?: 'GhostwriterFieldResponse' }
        | { __typename?: 'GhostwriterFormField' }
        | { __typename?: 'GhostwriterFormFieldGroup' }
        | { __typename?: 'GhostwriterJob' }
        | { __typename?: 'GhostwriterResponseGroup' }
        | { __typename?: 'GhostwriterResponseSet' }
        | { __typename?: 'HiringLabNationalAI' }
        | { __typename?: 'HiringLabNationalPayTransparency' }
        | { __typename?: 'HiringLabNationalPosting' }
        | { __typename?: 'HiringLabNationalRemote' }
        | { __typename?: 'HiringLabNationalWage' }
        | { __typename?: 'HiringLabRegionalPayTransparency' }
        | { __typename?: 'HiringLabRegionalPosting' }
        | { __typename?: 'HiringLabSectoralPayTransparency' }
        | { __typename?: 'HiringLabSectoralPosting' }
        | { __typename?: 'HiringLabSectoralRemote' }
        | { __typename?: 'HiringLabSectoralWage' }
        | { __typename?: 'HiringProfile' }
        | { __typename?: 'IAMConfiguration' }
        | { __typename?: 'InboundCandidateSyncConfiguration' }
        | { __typename?: 'InboundCandidateSyncResult' }
        | { __typename?: 'IndeedAssistantContextIndex' }
        | { __typename?: 'IndeedAssistantContextItemIngestionJob' }
        | { __typename?: 'IndeedAssistantEmbeddingProvider' }
        | { __typename?: 'InsertionOrder' }
        | { __typename?: 'InterviewLobby' }
        | { __typename?: 'InterviewLobbyAppointment' }
        | { __typename?: 'InterviewNowSession' }
        | { __typename?: 'InterviewRoom' }
        | { __typename?: 'InterviewTemplate' }
        | { __typename?: 'JPCorporateNumberCompanyData' }
        | { __typename?: 'JapanJobPostingForm' }
        | { __typename?: 'JobAlert' }
        | { __typename?: 'JobApplication' }
        | { __typename?: 'JobContentForm' }
        | { __typename?: 'JobMonetizationPolicy' }
        | { __typename?: 'JobPost' }
        | { __typename?: 'JobPostingForm' }
        | { __typename?: 'JobSeekerInvite' }
        | { __typename?: 'JobseekerInterviewNowSession' }
        | { __typename?: 'LibraryAuthor' }
        | { __typename?: 'LibraryBook' }
        | { __typename?: 'ManagedEmployerInterviewIntent' }
        | { __typename?: 'ManagedJobseekerInterviewIntent' }
        | { __typename?: 'MessageTemplate' }
        | { __typename?: 'MetadataCatalogDataAsset' }
        | { __typename?: 'MetadataCatalogDataAssetField' }
        | { __typename?: 'MultiLocationJobPostingForm' }
        | { __typename?: 'Notice' }
        | { __typename?: 'OneLogActivity' }
        | { __typename?: 'PartnerWebhook' }
        | { __typename?: 'PathfinderM2Suggestion' }
        | { __typename?: 'PathfinderSkill' }
        | { __typename?: 'PayrollPaycheck' }
        | { __typename?: 'PayrollShift' }
        | { __typename?: 'PphContract' }
        | { __typename?: 'PreApplyCandidate' }
        | { __typename?: 'Project' }
        | { __typename?: 'ProjectJobseeker' }
        | { __typename?: 'Proposal' }
        | { __typename?: 'RematchInvitation' }
        | { __typename?: 'ResourceGroup' }
        | { __typename?: 'RestrictedInterviewLobby' }
        | { __typename?: 'SchedulingParticipantGroup' }
        | { __typename?: 'ScoutAIDocument' }
        | { __typename?: 'ScoutApplication' }
        | { __typename?: 'ScoutChatMessage' }
        | { __typename?: 'ScoutConversation' }
        | { __typename?: 'ScoutDeepSourcingResult' }
        | { __typename?: 'ScoutMatchMeter' }
        | { __typename?: 'ScoutMatchProfile' }
        | { __typename?: 'ScoutMatchProfileDocument' }
        | {
              __typename?: 'SmartApplyApplicationState';
              id: string;
              draftId: string;
              questionsAndAnswers?:
                  | {
                        __typename?: 'ScreenerQuestionsAndAnswersSmartApplyApplicationState';
                        screener: Array<{
                            __typename?: 'QuestionAndAnswerSmartApplyApplicationState';
                            questionId: string;
                            answer?:
                                | { __typename?: 'FileAnswerSmartApplyApplicationState' }
                                | { __typename?: 'HierarchicalAnswerSmartApplyApplicationState' }
                                | { __typename?: 'MultiFieldAnswerSmartApplyApplicationState' }
                                | { __typename?: 'MultiFileAnswerSmartApplyApplicationState' }
                                | {
                                      __typename?: 'MultiTextAnswerSmartApplyApplicationState';
                                      valueList: Array<{
                                          __typename?: 'TextAnswerSmartApplyApplicationState';
                                          value: string;
                                      }>;
                                  }
                                | {
                                      __typename?: 'TextAnswerSmartApplyApplicationState';
                                      value: string;
                                  }
                                | null
                                | undefined;
                        }>;
                    }
                  | null
                  | undefined;
          }
        | { __typename?: 'SocialImpactJobseeker' }
        | { __typename?: 'SocialImpactPartner' }
        | { __typename?: 'SocialImpactPartnerAdmin' }
        | { __typename?: 'SourcingHitlPendingQuestion' }
        | { __typename?: 'SsiEmployerLink' }
        | { __typename?: 'SsiNotificationRule' }
        | { __typename?: 'SsiPlatformInstallation' }
        | { __typename?: 'StoredDataReport' }
        | { __typename?: 'SystemNotice' }
        | { __typename?: 'TalentProjectCandidateNote' }
        | { __typename?: 'TalentSubscription' }
        | { __typename?: 'TalentSubscriptionTemplate' }
        | { __typename?: 'TerraformModule' }
        | { __typename?: 'TerraformProject' }
        | { __typename?: 'TerraformTeam' }
        | { __typename?: 'TerraformWorkspace' }
        | { __typename?: 'TestEntity' }
        | { __typename?: 'TrustedMediaNetworkJob' }
        | { __typename?: 'WorkedShift' }
        | { __typename?: 'WorkedShiftMeal' }
        | { __typename?: 'WorkflowConfigRule' }
        | null
        | undefined;
};

export type UpdateLightApplyScreenerQuestionsMutationVariables = Types.Exact<{
    input: Types.SmartApplyApplicationStateInput;
    updateQuestionsInput: Types.UpdateQuestionsAndAnswersSmartApplyApplicationStateInput;
}>;

export type UpdateLightApplyScreenerQuestionsMutation = {
    __typename?: 'Mutation';
    smartApplyApplicationState: {
        __typename?: 'SmartApplyApplicationStateMutations';
        updateScreenerQuestionAnswers?:
            | {
                  __typename?: 'UpdateScreenerQuestionAnswersSmartApplyApplicationState';
                  payload: {
                      __typename?: 'ScreenerQuestionsAndAnswersSmartApplyApplicationState';
                      screener: Array<{
                          __typename?: 'QuestionAndAnswerSmartApplyApplicationState';
                          questionId: string;
                          answer?:
                              | { __typename?: 'FileAnswerSmartApplyApplicationState' }
                              | { __typename?: 'HierarchicalAnswerSmartApplyApplicationState' }
                              | { __typename?: 'MultiFieldAnswerSmartApplyApplicationState' }
                              | { __typename?: 'MultiFileAnswerSmartApplyApplicationState' }
                              | {
                                    __typename?: 'MultiTextAnswerSmartApplyApplicationState';
                                    valueList: Array<{
                                        __typename?: 'TextAnswerSmartApplyApplicationState';
                                        value: string;
                                    }>;
                                }
                              | {
                                    __typename?: 'TextAnswerSmartApplyApplicationState';
                                    value: string;
                                }
                              | null
                              | undefined;
                      }>;
                  };
              }
            | null
            | undefined;
    };
};

export const questionAndAnswerFieldsFragmentDoc = gql`
    fragment questionAndAnswerFields on DraftManagementQuestionAndAnswer {
        question {
            questionId
            type
            indeedTaxonomyParameters {
                parameterType
                parameterValue
                attributeUuid
            }
            qualification {
                ... on DraftManagementMatchQualification {
                    type
                    match {
                        values
                        type
                    }
                }
                ... on DraftManagementRangeQualification {
                    type
                    range {
                        min
                        max
                    }
                }
            }
            details {
                __typename
                ... on DraftManagementSelectQuestion {
                    label
                    condition
                    requirement
                    options {
                        value
                        label
                    }
                }
                ... on DraftManagementTextBoxQuestion {
                    label
                    dataType
                    maxLength
                    minValue
                    maxValue
                    requirement
                }
                ... on DraftManagementTextAreaQuestion {
                    label
                    maxLength
                    requirement
                }
                ... on DraftManagementDateQuestion {
                    label
                    format
                    minValue
                    maxValue
                    requirement
                }
                ... on DraftManagementFileQuestion {
                    label
                    acceptedFileExtensions
                    minValue
                    maxValue
                    requirement
                }
                ... on DraftManagementHierarchicalQuestion {
                    label
                    options {
                        value
                        label
                    }
                    hierarchicalOptions {
                        id
                        condition
                        options {
                            value
                            label
                        }
                    }
                    requirement
                }
                ... on DraftManagementPageBreak {
                    condition
                }
                ... on DraftManagementInformation {
                    rawText
                    htmlText
                    fontSize
                    condition
                }
            }
        }
        answer {
            ... on DraftManagementTextAnswer {
                value
            }
            ... on DraftManagementMultiTextAnswer {
                valueList {
                    value
                }
            }
            ... on DraftManagementFileAnswer {
                file {
                    uri
                }
            }
            ... on DraftManagementMultiFileAnswer {
                files {
                    file {
                        uri
                    }
                }
            }
            ... on DraftManagementHierarchicalAnswer {
                valueList {
                    id
                    value
                }
            }
        }
        suggestedAnswer {
            ... on DraftManagementTextSuggestedAnswer {
                suggestion {
                    value
                }
                questionViewTk
            }
            ... on DraftManagementMultiTextSuggestedAnswer {
                suggestions {
                    value
                }
                questionViewTk
            }
        }
    }
`;
export const GetScreenerQuestionsDataDocument = gql`
    query GetScreenerQuestionsData($filterInput: FindApplicationDraftsFilterInput!, $nodeId: ID!) {
        findApplicationDrafts(input: { filter: $filterInput }, first: 1) {
            operationDetails {
                applicationDraftId
                questionsAndAnswers {
                    screener {
                        ...questionAndAnswerFields
                    }
                }
            }
        }
        smartApplyApplicationState: node(id: $nodeId) {
            ... on SmartApplyApplicationState {
                id
                draftId
                questionsAndAnswers {
                    screener {
                        questionId
                        answer {
                            ... on TextAnswerSmartApplyApplicationState {
                                value
                            }
                            ... on MultiTextAnswerSmartApplyApplicationState {
                                valueList {
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    ${questionAndAnswerFieldsFragmentDoc}
`;

/**
 * __useGetScreenerQuestionsDataQuery__
 *
 * To run a query within a React component, call `useGetScreenerQuestionsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenerQuestionsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenerQuestionsDataQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useGetScreenerQuestionsDataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetScreenerQuestionsDataQuery,
        GetScreenerQuestionsDataQueryVariables
    > &
        ({ variables: GetScreenerQuestionsDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetScreenerQuestionsDataQuery, GetScreenerQuestionsDataQueryVariables>(
        GetScreenerQuestionsDataDocument,
        options,
    );
}
export function useGetScreenerQuestionsDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetScreenerQuestionsDataQuery,
        GetScreenerQuestionsDataQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetScreenerQuestionsDataQuery,
        GetScreenerQuestionsDataQueryVariables
    >(GetScreenerQuestionsDataDocument, options);
}
export function useGetScreenerQuestionsDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetScreenerQuestionsDataQuery,
              GetScreenerQuestionsDataQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetScreenerQuestionsDataQuery,
        GetScreenerQuestionsDataQueryVariables
    >(GetScreenerQuestionsDataDocument, options);
}
export type GetScreenerQuestionsDataQueryHookResult = ReturnType<
    typeof useGetScreenerQuestionsDataQuery
>;
export type GetScreenerQuestionsDataLazyQueryHookResult = ReturnType<
    typeof useGetScreenerQuestionsDataLazyQuery
>;
export type GetScreenerQuestionsDataSuspenseQueryHookResult = ReturnType<
    typeof useGetScreenerQuestionsDataSuspenseQuery
>;
export type GetScreenerQuestionsDataQueryResult = Apollo.QueryResult<
    GetScreenerQuestionsDataQuery,
    GetScreenerQuestionsDataQueryVariables
>;
export const UpdateLightApplyScreenerQuestionsDocument = gql`
    mutation UpdateLightApplyScreenerQuestions(
        $input: SmartApplyApplicationStateInput!
        $updateQuestionsInput: UpdateQuestionsAndAnswersSmartApplyApplicationStateInput!
    ) {
        smartApplyApplicationState(input: $input) {
            updateScreenerQuestionAnswers(input: $updateQuestionsInput) {
                payload {
                    screener {
                        questionId
                        answer {
                            ... on TextAnswerSmartApplyApplicationState {
                                value
                            }
                            ... on MultiTextAnswerSmartApplyApplicationState {
                                valueList {
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
export type UpdateLightApplyScreenerQuestionsMutationFn = Apollo.MutationFunction<
    UpdateLightApplyScreenerQuestionsMutation,
    UpdateLightApplyScreenerQuestionsMutationVariables
>;

/**
 * __useUpdateLightApplyScreenerQuestionsMutation__
 *
 * To run a mutation, you first call `useUpdateLightApplyScreenerQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLightApplyScreenerQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLightApplyScreenerQuestionsMutation, { data, loading, error }] = useUpdateLightApplyScreenerQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateQuestionsInput: // value for 'updateQuestionsInput'
 *   },
 * });
 */
export function useUpdateLightApplyScreenerQuestionsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateLightApplyScreenerQuestionsMutation,
        UpdateLightApplyScreenerQuestionsMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateLightApplyScreenerQuestionsMutation,
        UpdateLightApplyScreenerQuestionsMutationVariables
    >(UpdateLightApplyScreenerQuestionsDocument, options);
}
export type UpdateLightApplyScreenerQuestionsMutationHookResult = ReturnType<
    typeof useUpdateLightApplyScreenerQuestionsMutation
>;
export type UpdateLightApplyScreenerQuestionsMutationResult =
    Apollo.MutationResult<UpdateLightApplyScreenerQuestionsMutation>;
export type UpdateLightApplyScreenerQuestionsMutationOptions = Apollo.BaseMutationOptions<
    UpdateLightApplyScreenerQuestionsMutation,
    UpdateLightApplyScreenerQuestionsMutationVariables
>;
